import React from 'react'
import './LandscapeApp.css'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  withRouter,
} from 'react-router-dom'
import LandCustomTitleBar from './common/LandCustomTitleBar.js'
import LandMainPage from './page/LandMainPage.js'
import LandProductListPage from './page/LandProductListPage.js'
import LandProductDetailPage from './page/LandProductDetailPage.js'
import LandCompanyPage from './page/LandCompanyPage.js'
import LandContactPage from './page/LandContactPage.js'
import LandContractTermsPage from './page/LandContractTermsPage.js'
import LandPrivacyPolicyPage from './page/LandPrivacyPolicyPage.js'
import LandThirdPartySDKsPage from './page/LandThirdPartySDKsPage.js'
import LandProductLinePage from './page/innovation/LandProductLinePage.js'
import LandOverallSolutionPage from './page/innovation/LandOverallSolutionPage.js'
import LandOnsiteGuidancePage from './page/innovation/LandOnsiteGuidancePage.js'
import LandIndustryDetailPage from './page/LandIndustryDetailPage.js'
import LandCertificatesPage from './page/certificate/LandCertificatesPage.js'
import LandProductDrawer from './drawer/LandProductDrawer.js'
import LandIndustryDrawer from './drawer/LandIndustryDrawer'
import LandCompanyDrawer from './drawer/LandCompanyDrawer.js'
import LandInnovationDrawer from './drawer/LandInnovationDrawer.js'
import { productDrawerHeight } from './drawer/LandProductDrawer.js'
import { companyDrawerHeight } from './drawer/LandCompanyDrawer.js'
import { industryDrawerHeight } from './drawer/LandIndustryDrawer'
import { innovationDrawerHeight } from './drawer/LandInnovationDrawer.js'

class LandscapeApp extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      homeProps: {
        menuRef: React.createRef(),
      },
      productProps: {
        menuRef: React.createRef(),
        drawerHeight: productDrawerHeight,
      },
      industryProps: {
        menuRef: React.createRef(),
        drawerHeight: industryDrawerHeight,
      },
      companyProps: {
        menuRef: React.createRef(),
        drawerHeight: companyDrawerHeight,
      },
      innovationProps: {
        menuRef: React.createRef(),
        drawerHeight: innovationDrawerHeight,
      },
    }
    this.titleBarRef = React.createRef()
  }

  render() {
    return (
      <div className="Landscape" onMouseMove={this.checkAllDrawerOpenStatus}>
        <LandCustomTitleBar
          getCurrentSelectedTitlebarSelectedItemKeys={
            this.getCurrentSelectedTitlebarSelectedItemKeys
          }
          titleBarRef={this.titleBarRef}
          homeProps={this.state.homeProps}
          productProps={this.state.productProps}
          industryProps={this.state.industryProps}
          companyProps={this.state.companyProps}
          innovationProps={this.state.innovationProps}
          {...this.props}
        />

        <LandProductDrawer
          open={this.state.productProps.drawerOpening}
          handleClose={() =>
            this.closeDrawerOnClickMenuItem(this.state.productProps)
          }
          {...this.props}
        />

        <LandIndustryDrawer
          open={this.state.industryProps.drawerOpening}
          handleClose={() =>
            this.closeDrawerOnClickMenuItem(this.state.industryProps)
          }
          {...this.props}
        />

        <LandCompanyDrawer
          open={this.state.companyProps.drawerOpening}
          handleClose={() =>
            this.closeDrawerOnClickMenuItem(this.state.companyProps)
          }
          {...this.props}
        />

        <LandInnovationDrawer
          open={this.state.innovationProps.drawerOpening}
          handleClose={() =>
            this.closeDrawerOnClickMenuItem(this.state.innovationProps)
          }
          {...this.props}
        />

        <Switch>
          <Route
            exact
            path="/"
            render={(props) => <LandMainPage {...props} />}
          />
          <Route
            exact
            path="/product_list"
            render={(props) => <LandProductListPage {...props} />}
          />
          <Route
            exact
            path="/product"
            render={(props) => <LandProductDetailPage {...props} />}
          />
          <Route
            exact
            path="/company"
            render={(props) => <LandCompanyPage {...props} />}
          />
          <Route
            exact
            path="/contact"
            render={(props) => <LandContactPage {...props} />}
          />
          <Route
            exact
            path="/contract_terms"
            render={(props) => <LandContractTermsPage {...props} />}
          />
          <Route
            exact
            path="/privacy_policy"
            render={(props) => <LandPrivacyPolicyPage {...props} />}
          />
          <Route
            exact
            path="/thirdparty_sdks"
            render={(props) => <LandThirdPartySDKsPage {...props} />}
          />
          <Route
            exact
            path="/product_line"
            render={(props) => <LandProductLinePage {...props} />}
          />
          <Route
            exact
            path="/overall_solution"
            render={(props) => <LandOverallSolutionPage {...props} />}
          />
          <Route
            exact
            path="/onsite_guidance"
            render={(props) => <LandOnsiteGuidancePage {...props} />}
          />
          <Route
            exact
            path="/industry"
            render={(props) => <LandIndustryDetailPage {...props} />}
          />
          <Route
            exact
            path="/certificates"
            render={(props) => <LandCertificatesPage {...props} />}
          />
        </Switch>
      </div>
    )
  }

  getCurrentSelectedTitlebarSelectedItemKeys = () => {
    // if (this.state.homeProps.selected) {
    //   return ['home']
    // }
    // if (this.state.productProps.selected) {
    //   return ['product']
    // }
    // if (this.state.industryProps.selected) {
    //   return ['industry']
    // }
    // if (this.state.companyProps.selected) {
    //   return ['company']
    // }
    // if (this.state.innovationProps.selected) {
    //   return ['innovation']
    // }
    // return null
    return this.state.selectedKeys
  }

  checkAllDrawerOpenStatus = (event) => {
    this.checkSingleDrawerOpenStatus(event, this.state.homeProps)
    this.checkSingleDrawerOpenStatus(event, this.state.productProps)
    this.checkSingleDrawerOpenStatus(event, this.state.industryProps)
    this.checkSingleDrawerOpenStatus(event, this.state.companyProps)
    this.checkSingleDrawerOpenStatus(event, this.state.innovationProps)
    this.setState({ selectedKeys: [] })
  }

  checkSingleDrawerOpenStatus = (event, props) => {
    let titleBarHeight = this.titleBarRef.current.offsetHeight
    let rect = props.menuRef.current.getBoundingClientRect()
    if (props.drawerOpening) {
      if (
        event.clientY < rect.top ||
        event.clientY > titleBarHeight + props.drawerHeight ||
        (event.clientY >= rect.top &&
          event.clientY <= titleBarHeight &&
          (event.clientX < rect.left || event.clientX > rect.right))
      ) {
        props.drawerOpening = false
        props.menuIconRotateDown = true
        props.menuIconRotated = true
        setTimeout(() => {
          props.menuIconRotateDown = false
        }, 1000)
      }
    } else if (props != this.state.homeProps) {
      if (
        event.clientY >= rect.top &&
        event.clientY <= titleBarHeight &&
        event.clientX >= rect.left &&
        event.clientX <= rect.right
      ) {
        props.drawerOpening = true
        props.menuIconRotateUp = true
        props.menuIconRotated = true
        setTimeout(() => {
          props.menuIconRotateUp = false
        }, 1000)
      }
    }
  }

  closeDrawerOnClickMenuItem = (props) => {
    props.drawerOpening = false
    props.menuIconRotateDown = true
    props.menuIconRotated = true
    setTimeout(() => {
      props.menuIconRotateDown = false
    }, 1000)
    this.setState({})
  }
}

export default withRouter(LandscapeApp)
